import "@/App.css";
import { BrowserRouter, Routes, Route, useLocation } from "react-router-dom";
import { useEffect } from "react";
import { Toaster } from "./components/ui/sonner";
import { Navbar } from "./components/Navbar";
import { Footer } from "./components/Footer";
import { StickyCallButton } from "./components/StickyCallButton";
import { InstallPrompt } from "./components/InstallPrompt";
import { AuthProvider } from "./context/AuthContext";
import Home from "./pages/Home";
import Services from "./pages/Services";
import Contact from "./pages/Contact";
import Admin from "./pages/Admin";
import Pay from "./pages/Pay";
import PaymentSuccess from "./pages/PaymentSuccess";
import Terms from "./pages/Terms";
import AgreeTerms from "./pages/AgreeTerms";
import Membership from "./pages/Membership";
import MembershipSuccess from "./pages/MembershipSuccess";
import MembershipAgreement from "./pages/MembershipAgreement";
import CancellationPolicy from "./pages/CancellationPolicy";
import Portal from "./pages/Portal";
import AuthCallback from "./pages/AuthCallback";
import Tech from "./pages/Tech";
import EstimatePublic from "./pages/EstimatePublic";
import ServiceDetail from "./pages/ServiceDetail";

const ScrollToTop = () => {
  const { pathname } = useLocation();
  useEffect(() => window.scrollTo(0, 0), [pathname]);
  return null;
};

const AppRouter = () => {
  const location = useLocation();
  // Google OAuth callback: process session_id before any route/auth checks run
  if (location.hash?.includes("session_id=")) {
    return <AuthCallback />;
  }
  return (
    <Routes>
      <Route path="/" element={<Home />} />
      <Route path="/services" element={<Services />} />
      <Route path="/services/:slug" element={<ServiceDetail />} />
      <Route path="/contact" element={<Contact />} />
      <Route path="/pay" element={<Pay />} />
      <Route path="/membership" element={<Membership />} />
      <Route path="/membership/success" element={<MembershipSuccess />} />
      <Route path="/membership-agreement" element={<MembershipAgreement />} />
      <Route path="/cancellation-policy" element={<CancellationPolicy />} />
      <Route path="/portal" element={<Portal />} />
      <Route path="/tech" element={<Tech />} />
      <Route path="/estimate/:token" element={<EstimatePublic />} />
      <Route path="/admin" element={<Admin />} />
      <Route path="/payment-success" element={<PaymentSuccess />} />
      <Route path="/terms" element={<Terms />} />
      <Route path="/agree/:leadId" element={<AgreeTerms />} />
    </Routes>
  );
};

function App() {
  return (
    <BrowserRouter>
      <AuthProvider>
        <ScrollToTop />
        <Navbar />
        <AppRouter />
        <Footer />
        <StickyCallButton />
        <InstallPrompt />
        <Toaster position="top-center" richColors />
      </AuthProvider>
    </BrowserRouter>
  );
}

export default App;
